import { createBrowserHistory } from 'history';

// 共用瀏覽器 history，供 <Router> 與未來元件外導航使用
const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const history = createBrowserHistory({ basename: baseUrl });

export default history;
